import React from "react";

const PREVIEW_LIMIT = 3;

const resolveProductName = (gtin, products) => {
  const product = products?.find((p) => String(p.gtin) === String(gtin));
  return product?.name || gtin;
};

export const getPromoGtins = (item) => {
  if (item?.targetProducts?.length > 0) {
    return item.targetProducts
      .map((tp) => (typeof tp === "string" ? tp : tp?.gtin))
      .filter(Boolean);
  }
  return item?.gtin ? [item.gtin] : [];
};

export const getPromoCardTitle = (item, products) => {
  const manualText = item?.description || item?.Text || "";
  if (manualText) return manualText;

  const gtins = getPromoGtins(item);
  if (!gtins.length) return "מבצע ללא כותרת";
  if (gtins.length === 1) {
    return resolveProductName(gtins[0], products) || "מבצע ללא כותרת";
  }
  return `${gtins.length} מוצרים במבצע`;
};

const PromoCardProducts = ({ gtins, products, onShowAll }) => {
  if (!gtins.length) {
    return (
      <div className="promo-card__products">
        <span className="promo-card__products-empty">אין מוצרים במבצע</span>
      </div>
    );
  }

  const previewGtins = gtins.slice(0, PREVIEW_LIMIT);
  const hiddenCount = gtins.length - previewGtins.length;

  return (
    <div className="promo-card__products">
      <span className="promo-card__products-label">
        מוצרים במבצע ({gtins.length})
      </span>
      <ul className="promo-card__products-list">
        {previewGtins.map((gtin) => (
          <li key={gtin} className="promo-card__products-item">
            {resolveProductName(gtin, products)}
          </li>
        ))}
      </ul>
      {hiddenCount > 0 ? (
        <button
          type="button"
          className="promo-card__products-more"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onShowAll();
          }}
        >
          ועוד {hiddenCount} מוצרים — לחץ לפירוט
        </button>
      ) : null}
    </div>
  );
};

export const PromoProductsModal = ({ promo, products, onClose }) => {
  if (!promo) return null;

  const gtins = getPromoGtins(promo);

  return (
    <div className="promo-products-modal" role="presentation" onClick={onClose}>
      <div
        className="promo-products-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="promo-products-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="promo-products-modal-title"
          className="promo-products-modal__title"
        >
          מוצרים במבצע ({gtins.length})
        </h3>
        <ul className="promo-products-modal__list">
          {gtins.map((gtin) => (
            <li key={gtin} className="promo-products-modal__item">
              <span className="promo-products-modal__name">
                {resolveProductName(gtin, products)}
              </span>
              <span className="promo-products-modal__gtin">{gtin}</span>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="promo-products-modal__close"
          onClick={onClose}
        >
          סגור
        </button>
      </div>
    </div>
  );
};

export default PromoCardProducts;
